<era-panel>
  <era-panel-header>
    <era-title>
      <span title
            i18n>Locations</span>

      <era-context-menu [isEditing]="editEnabled"
                        (selectedEdit)="toggleEdit()"
                        canEdit="true">
        <button ngbDropdownItem
                (click)="openSettings()">Settings</button>
        <button ngbDropdownItem
                (click)="exportDevices()">Export</button>
      </era-context-menu>
    </era-title>
    <div class="border-bottom"></div>
  </era-panel-header>

  <ml-sk-spinner-3 [hidden]="!!locations()"></ml-sk-spinner-3>
  <div class="list-group">
    @for (location of locations(); track location) {
      <ng-container *ngTemplateOutlet="locationsTemplate(); context: { $implicit: location, editEnabled: editEnabled }">
      </ng-container>
    }
    <ng-container *ngTemplateOutlet="addLocationTemplate(); context: { editEnabled: editEnabled }"> </ng-container>
  </div>
</era-panel>